import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Motorcade-index-1992f2b78ca3bd51c-1'),
    routerUrl: '/Motorcade',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Motorcade')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Motorcade-index-1992f2b78ca3bd51c-2'),
        routerUrl: '/MotorcadeForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./MotorcadeForm')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Motorcade-index-1992f2b78ca3bd51c-3'),
        routerUrl: '/MotorcadeUnlock',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./MotorcadeUnlock')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Motorcade-index-1992f2b78ca3bd51c-4'),
        routerUrl: '/MotorcadeRefillForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./MotorcadeRefillForm')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Motorcade-index-1992f2b78ca3bd51c-5'),
        routerUrl: '/MotorcadeRefill',
        resourceIcon: '',
        type: '2',
        buttons: [],
        noparent: true,
        component: loadable(() => import('./MotorcadeRefill')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Motorcade-index-1992f2b78ca3bd51c-6'),
        routerUrl: '/MotorcadeRefuel',
        resourceIcon: '',
        type: '2',
        buttons: [],
        noparent: true,
        component: loadable(() => import('./MotorcadeRefuel')),
      },

      //$MORE$
    ],
  },
];
